import _ from 'underscore';

import {EventConstants} from 'constants/EventConstants';
import {Batch} from 'constants/SampleConstants';
import AppDispatcher from 'lib/Dispatcher';

import * as StorableActions from './StorableActions';
import {ListContainableContainersOptions} from './StorableActions';
import StorableStore from './StorableStore';

/**
 * Find all existing container listings for containableId and relist them
 */
export function relistContainersForContainable(
  containableId: string,
  options: ListContainableContainersOptions = {}
): void {
  const containerListings = StorableStore.getContainableContainerListings();
  for (const listingId of StorableStore.getListingIdsByContainableId(containableId)) {
    const listing = containerListings[listingId];
    if (listing && listing.pagination && listing.pagination.offset === 0) {
      StorableActions.listContainableContainers(
        listingId,
        containableId,
        0,
        listing.pagination.limit,
        options
      );
    }
  }
}

export function handleBatchesLoaded(batches: Array<Batch>): void {
  AppDispatcher.dispatch({
    actionType: EventConstants.BATCHES_BULK_FETCH_COMPLETED,
    batchesById: _.indexBy(batches, 'id'),
  });
}
